<template>
    <div class="main text-center">
        <v-card class="ma-3">
            <v-card-title class="headline">Přihlášení</v-card-title>
            <v-card-text>
                <v-form
                        ref="form"
                        v-model="valid"
                        @keyup.enter="validate"
                >
                    <v-text-field
                            v-model="username"
                            :rules="usernameRules"
                            label="Uživatelské jméno"
                            ref="username"
                            required
                    ></v-text-field>

                    <v-text-field
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="showPassword ? 'text' : 'password'"
                            v-model="password"
                            :rules="passwordRules"
                            label="Heslo"
                            @keyup.enter="validate"
                            required
                            class="mt-5"
                            @click:append="showPassword = !showPassword"
                    ></v-text-field>
                </v-form>

                <v-alert v-if="loginError" type="error">
                    Chyba přihlašování, zkontrolujte přihlašovací údaje
                </v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn
                        :disabled="!valid"
                        color="success"
                        @click="validate"
                >
                    Přihlásit
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
    export default {
        data: () => ({
            valid: true,
            username: '',
            usernameRules: [
                v => !!v || 'Vyplňte uživatelské jméno',
            ],
            password: '',
            passwordRules: [
                v => !!v || 'Vyplňte heslo',
            ],
            showPassword: false,
            loginError: false
        }),

        mounted () {
            this.$refs['username'].focus()
        },

        methods: {
            async validate () {
                this.loginError = false

                if (this.$refs.form.validate()) {
                    const result = await this.$store.dispatch('user/login', {
                        username: this.username,
                        password: this.password
                    })
                    if (result.ok) {
                        this.$router.push({name:'events'})
                    } else {
                        this.loginError = true
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main {
        width: 100%;
        max-width: 500px;
    }
</style>